import React from 'react';
import css from './ListingsTable.module.css';
import { capitalizeFirstLetter } from '../../../util/genericHelpers';
import { formatMoney } from '../../../util/currency';
import { SecondaryButton } from '../../../components';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

const TableGrid = ({
  id,
  title,
  imageUrl,
  price,
  state,
  createdAt,
  currentStock,
  handleSelectItem,
  intl,
  selectedItems,
  navigateToEditListingPage,
  navigateToCopyListingPage,
  listing,
  copyListingId,
}) => {
  const formattedPrice = price?.amount && formatMoney(intl, price);

  const handleRowClick = e => {
    // Don't navigate if clicking on checkbox or button
    if (e.target.closest('input[type="checkbox"]') || e.target.closest('button')) {
      return;
    }
    navigateToEditListingPage(id?.uuid, title);
  };

  return (
    <div
      key={id.uuid}
      className={classNames(css.listingBlock, css.clickableBlock)}
      onClick={handleRowClick}
    >
      <div className={css.listingImage}>
        <label className={css.mobileCheckboxCell} onClick={e => e.stopPropagation()}>
          <input
            type="checkbox"
            checked={selectedItems.includes(id.uuid)}
            onChange={() => handleSelectItem(id.uuid)}
            className={css.checkbox}
            aria-label={`Select ${title || 'listing'}`}
          />
        </label>
        <img src={imageUrl} alt={title || 'Listing Image'} />
      </div>
      <div className={css.listingInfo}>
        <h3>{capitalizeFirstLetter(title) || 'No Title'}</h3>
        <p className={css.price}>{formattedPrice}</p>
        <p>{capitalizeFirstLetter(state)}</p>

        <p>{new Date(createdAt).toLocaleDateString()}</p>
        <p>{currentStock?.attributes?.quantity || 'N/A'}</p>
        <div onClick={e => e.stopPropagation()}>
          <SecondaryButton
            type="button"
            onClick={() => navigateToCopyListingPage(listing)}
            inProgress={copyListingId === id.uuid}
            disabled={copyListingId === id.uuid}
          >
            <FormattedMessage id="ShopSettingsForm.copyButton" />
          </SecondaryButton>
        </div>
      </div>
    </div>
  );
};

export default TableGrid;
